import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'formly-designer-wrapper',
    template: `
        <ng-template #fieldComponent></ng-template>
    `
})
export class FormlyDesignerWrapperComponent extends FieldWrapper {
    @ViewChild('fieldComponent', { read: ViewContainerRef, static: true }) fieldComponent: ViewContainerRef;
}
